import React from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-svg';

import logo from '@betwixt/common/assets/images/logo.svg';
import LanguageSelector from './LanguageSelector.js';
import '@betwixt/common/scss/footer.scss';

const Footer = (props) => {
  const { i18n, without_logo, without_language, without_privacylink, type, gConfig } = props;

  return (
    <div id="footer" className={`container ${type}`}>
      {!without_logo && (
        <div
          style={
            without_language || without_privacylink ? { justifyContent: 'center', order: 1 } : {}
          }
        >
          <a href={`${gConfig.protocol}://${gConfig.sections.web.hostname}`}>
            <SVG src={logo} className="logo" />
          </a>
        </div>
      )}
      <div
        className="container-menu"
        style={
          without_language || without_privacylink ? { justifyContent: 'center', order: 0 } : {}
        }
      >
        {!without_language && (
          <nav>
            {' '}
            <LanguageSelector i18n={i18n} />{' '}
          </nav>
        )}
        {!without_privacylink && (
          <nav>
            <a href={`${gConfig.protocol}://${gConfig.sections.web.hostname}/privacy-policy`}>
              Privacy Policy
            </a>
            <a href={`${gConfig.protocol}://${gConfig.sections.web.hostname}/cookie-policy`}>
              Cookie Policy
            </a>
          </nav>
        )}
      </div>
    </div>
  );
};

export default Footer;

Footer.propTypes = {
  i18n: PropTypes.object,
  without_logo: PropTypes.bool,
  without_language: PropTypes.bool,
  without_privacylink: PropTypes.bool,
  type: PropTypes.string,
  gConfig: PropTypes.shape({
    protocol: PropTypes.string,
    sections: PropTypes.shape({
      web: PropTypes.shape({
        hostname: PropTypes.string,
      }),
    }),
  }),
};
